import { PaymentProvider } from '@/api/types/payments.types';
import { AZERICARD_DELAY_TIME_MS } from '@/constants/common';

export function getRefetchDelay(paymentProvider: PaymentProvider | null) {
  switch (paymentProvider) {
    case PaymentProvider.Azericard:
      return AZERICARD_DELAY_TIME_MS;
    default:
      return 0;
  }
}
